<template>
	<el-dialog :title="title" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
			<el-form-item label="配置包名称" prop="bundleName">
				<el-input v-model="form.bundleName" placeholder="请输入配置包名称"></el-input>
			</el-form-item>
			<el-form-item label="配置包编码" prop="bundleCode">
				<el-input v-model="form.bundleCode" placeholder="请输入配置包编码"></el-input>
			</el-form-item>
			<el-form-item label="排序值" prop="sort">
				<el-input-number v-model="form.sort" placeholder="请输入排序值" :min="1" :max="9999" :step="1"></el-input-number>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillBundleAdd, courseSkillBundleUpdate } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			title: "新增配置包",
			form: {
				skillId: "",
				bundleName: "",
				bundleCode: "",
				sort: 1,
			},
			rules: {
				bundleName: [{ required: true, message: "请输入配置包名称", trigger: "blur" }],
				bundleCode: [{ required: true, message: "请输入配置包编码", trigger: "blur" }],
			},
		};
	},
	methods: {
		// 初始化弹窗
		init(skillId, dt) {
			this.dialogVisible = true;
			this.submitLoading = false;
			// 等待DOM更新后重置表单
			this.$nextTick(() => {
				this.$refs.form.resetFields();
				this.title = dt ? "编辑配置包" : "新增配置包";
				this.form = dt ? { ...dt, skillId } : { skillId, bundleName: "", bundleCode: "", sort: 1 };
			});
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 提交表单
		handleSubmit: debounce(function () {
			this.$refs.form.validate((valid) => {
				if (!valid) return;
				if (this.submitLoading) return;
				this.handleClose();
				const api = this.form.id ? courseSkillBundleUpdate : courseSkillBundleAdd;
				const msg = this.form.id ? "编辑成功" : "新增成功";
				api(this.form).then((res) => {
					this.submitLoading = false;
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success(msg);

					this.$emit("getBundleList", this.form.skillId);
				});
			});
		}, 300),
	},
};
</script>

<style scoped></style>
